module.exports = __webpack_public_path__ + "img/Host.55bd059f.svg";